function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { Message } from '@wegic/ui';
import md5 from 'md5';
import { useCallback, useState } from 'react';
import { UNREGISTERED_CODE } from '@/const/code';
import { getUserInfo, registerByEmail } from '@/services/auth';
import { createUserRequest } from '@/services/request';
import { buildAuthParamsWithAnonymous } from '@/utils';
/**
 * 邮箱登录 Hook
 */ export function useEmailLogin(config) {
    var _ref = config || {}, apiConfig = _ref.apiConfig, getAnonymousId = _ref.getAnonymousId, onEvent = _ref.onEvent;
    var _useState = _sliced_to_array(useState(false), 2), loading = _useState[0], setLoading = _useState[1];
    var _useState1 = _sliced_to_array(useState(null), 2), error = _useState1[0], setError = _useState1[1];
    var userRequest = createUserRequest(apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.baseURL);
    var login = useCallback(function(email, password) {
        return _async_to_generator(function() {
            var formData, transformData, requestConfig, res, code, userInfoRes, user, err, errorMessage;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        setError(null);
                        formData = buildAuthParamsWithAnonymous({
                            email: email,
                            password: password
                        }, getAnonymousId);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        transformData = _object_spread_props(_object_spread({}, formData), {
                            password: md5(password)
                        });
                        requestConfig = {
                            allowedCodes: [
                                UNREGISTERED_CODE
                            ]
                        };
                        return [
                            4,
                            userRequest.post('/accounts/email/login', transformData, requestConfig)
                        ];
                    case 2:
                        res = _state.sent();
                        code = res.code;
                        if (!(code === 0)) return [
                            3,
                            5
                        ];
                        Message.success(intl.get('Login_Success_Message'));
                        return [
                            4,
                            userRequest.get('/accounts')
                        ];
                    case 3:
                        userInfoRes = _state.sent();
                        user = userInfoRes.data;
                        return [
                            4,
                            onEvent === null || onEvent === void 0 ? void 0 : onEvent({
                                type: 'login:email:success',
                                data: user
                            })
                        ];
                    case 4:
                        _state.sent();
                        setLoading(false);
                        return [
                            2,
                            {
                                success: true,
                                user: user
                            }
                        ];
                    case 5:
                        // 未注册
                        if (code === UNREGISTERED_CODE) {
                            onEvent === null || onEvent === void 0 ? void 0 : onEvent({
                                type: 'register:start',
                                formData: formData
                            });
                            setLoading(false);
                            return [
                                2,
                                {
                                    success: false,
                                    needRegister: true,
                                    formData: formData
                                }
                            ];
                        }
                        // 其他错误
                        setLoading(false);
                        return [
                            2,
                            {
                                success: false
                            }
                        ];
                    case 6:
                        err = _state.sent();
                        errorMessage = (err === null || err === void 0 ? void 0 : err.message) || intl.get('Login_Failed_Message');
                        setError(errorMessage);
                        onEvent === null || onEvent === void 0 ? void 0 : onEvent({
                            type: 'error',
                            error: {
                                message: errorMessage,
                                type: 'auth'
                            },
                            source: 'email-login'
                        });
                        setLoading(false);
                        return [
                            2,
                            {
                                success: false,
                                error: errorMessage
                            }
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.baseURL,
        getAnonymousId,
        onEvent
    ]);
    return {
        login: login,
        loading: loading,
        error: error
    };
}
/**
 * 邮箱注册 Hook
 */ export function useEmailRegister(config) {
    var _ref = config || {}, apiConfig = _ref.apiConfig, getAnonymousId = _ref.getAnonymousId, onEvent = _ref.onEvent;
    var _useState = _sliced_to_array(useState(false), 2), loading = _useState[0], setLoading = _useState[1];
    var _useState1 = _sliced_to_array(useState(null), 2), error = _useState1[0], setError = _useState1[1];
    var userRequest = createUserRequest(apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.baseURL);
    var register = useCallback(function(params) {
        return _async_to_generator(function() {
            var res, _ref, user, err, errorMessage;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        setError(null);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4,
                            registerByEmail(buildAuthParamsWithAnonymous({
                                email: params.email,
                                password: params.password,
                                code: params.code
                            }, getAnonymousId))
                        ];
                    case 2:
                        res = _state.sent();
                        if (!(res.code === 0)) return [
                            3,
                            5
                        ];
                        Message.success(intl.get('Register_Success_Message'));
                        return [
                            4,
                            getUserInfo()
                        ];
                    case 3:
                        _ref = _state.sent(), user = _ref.data;
                        return [
                            4,
                            onEvent === null || onEvent === void 0 ? void 0 : onEvent({
                                type: 'register:success',
                                data: user
                            })
                        ];
                    case 4:
                        _state.sent();
                        setLoading(false);
                        return [
                            2,
                            {
                                success: true,
                                user: user
                            }
                        ];
                    case 5:
                        setLoading(false);
                        return [
                            2,
                            {
                                success: false
                            }
                        ];
                    case 6:
                        err = _state.sent();
                        errorMessage = (err === null || err === void 0 ? void 0 : err.message) || intl.get('Register_Failed_Message');
                        setError(errorMessage);
                        onEvent === null || onEvent === void 0 ? void 0 : onEvent({
                            type: 'error',
                            error: {
                                message: errorMessage,
                                type: 'auth'
                            },
                            source: 'register'
                        });
                        setLoading(false);
                        return [
                            2,
                            {
                                success: false,
                                error: errorMessage
                            }
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        getAnonymousId,
        onEvent
    ]);
    var sendVerifyCode = useCallback(function(email, sendType) {
        return _async_to_generator(function() {
            var err, errorMessage;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            userRequest.post('/accounts/verification-codes/email', {
                                usage: sendType,
                                email: email
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2,
                            {
                                success: true
                            }
                        ];
                    case 2:
                        err = _state.sent();
                        errorMessage = (err === null || err === void 0 ? void 0 : err.message) || intl.get('Send_Code_Failed');
                        onEvent === null || onEvent === void 0 ? void 0 : onEvent({
                            type: 'error',
                            error: {
                                message: errorMessage,
                                type: 'network'
                            },
                            source: 'verify-code'
                        });
                        return [
                            2,
                            {
                                success: false,
                                error: errorMessage
                            }
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.baseURL,
        onEvent
    ]);
    return {
        register: register,
        sendVerifyCode: sendVerifyCode,
        loading: loading,
        error: error
    };
}
/**
 * 密码重置 Hook
 */ export function usePasswordReset(config) {
    var _ref = config || {}, apiConfig = _ref.apiConfig, onEvent = _ref.onEvent;
    var _useState = _sliced_to_array(useState(false), 2), loading = _useState[0], setLoading = _useState[1];
    var _useState1 = _sliced_to_array(useState(null), 2), error = _useState1[0], setError = _useState1[1];
    var userRequest = createUserRequest(apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.baseURL);
    var resetPassword = useCallback(function(params) {
        return _async_to_generator(function() {
            var transformData, res, user, err, errorMessage;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        setError(null);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        transformData = _object_spread_props(_object_spread({}, params), {
                            type: 'email',
                            password: md5(params.password)
                        });
                        return [
                            4,
                            userRequest.patch('/password', transformData)
                        ];
                    case 2:
                        res = _state.sent();
                        if (res.code === 0) {
                            Message.success(intl.get('Reset_Password_Success'));
                            user = res.data;
                            onEvent === null || onEvent === void 0 ? void 0 : onEvent({
                                type: 'password:reset:success',
                                data: user
                            });
                            setLoading(false);
                            return [
                                2,
                                {
                                    success: true,
                                    user: user
                                }
                            ];
                        }
                        setLoading(false);
                        return [
                            2,
                            {
                                success: false
                            }
                        ];
                    case 3:
                        err = _state.sent();
                        errorMessage = (err === null || err === void 0 ? void 0 : err.message) || intl.get('Reset_Password_Failed');
                        setError(errorMessage);
                        onEvent === null || onEvent === void 0 ? void 0 : onEvent({
                            type: 'error',
                            error: {
                                message: errorMessage,
                                type: 'auth'
                            },
                            source: 'password-reset'
                        });
                        setLoading(false);
                        return [
                            2,
                            {
                                success: false,
                                error: errorMessage
                            }
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.baseURL,
        onEvent
    ]);
    return {
        resetPassword: resetPassword,
        loading: loading,
        error: error
    };
}
